import React from 'react';
import Stock from '../../model/DashboardStock' 
import DashboardFilter from './DashboardFilter';
import { useDispatch, useSelector } from 'react-redux';
import selectStocks from '../../selectors/dashboard-stocks'
import DashboardItem from './DashboardItem';
import api from '../../api/api';
import { loading } from '../../actions/Loading'
import DashboardTable from './DashboardTable'
import styled from 'styled-components'
import useAsyncEffect from 'use-async-effect';
import { IGlobalState } from '../../model/IGlobalState'
import * as Roles from '../../model/Roles';

interface IProps {
  
}

const Style = styled.div`
@media (min-width: 768px) {
  .dashboard-item-container{
      display:none;
    } 
  }

  .filter-info {
    margin-top: 5px;
    display:flex;
    justify-content: space-between;
  }
  .num-displayed {
    font-size:10px;
    font-style:italic;
  }

  table {
    margin-top: 10px;
  }

`
const Dashboard: React.FC<IProps> = (props: IProps) => {
  let dashboard_stocks = useSelector((state: IGlobalState) => state.dashboard_stocks)
  const filters = useSelector((state: IGlobalState) => state.filters)
  const user = useSelector((state: IGlobalState) => state.user);
  const stocks = selectStocks(dashboard_stocks, filters);

  const archivedMatchCount = stocks.length === 0 && filters.text && filters.billable !== 'Archived'
    ? selectStocks(dashboard_stocks, { text: filters.text, billable: 'Archived' }).length
    : 0;
  const dispatch = useDispatch();

  useAsyncEffect(async ()=> {
    dispatch(loading(true));
    await api().loadDashboardStocks();
    dispatch(loading(false));
  }, []);

  const showTotal = user.roles.hasOwnProperty(Roles.InvoiceTotal)
  let total:number = 0;
  if(showTotal){
    total = stocks.reduce((a, b) => {
      if (!b.repeatingInvoice?.lineItems?.length) return a;
      const invoiceTotal = b.repeatingInvoice.lineItems.reduce((sum, item) => {
        const val = item.unitAmount;
        if (!val) return sum;
        return sum + val;
      }, 0);
      const schedule = b.repeatingInvoice.schedule;
      if (!schedule?.period) return a + invoiceTotal;
      // unitAmount is ex-GST (all invoices are LineAmountTypes Exclusive)
      const perYear = (schedule.unit === 'MONTHLY' ? 12 : 52) / schedule.period;
      return a + invoiceTotal * perYear;
    }, 0)
  }
  
  
  return <Style className="padding">

    <DashboardFilter />
  
    <div className="filter-info">
      <div><span>Filters:  </span>
        {!!filters.text && <em>{filters.text}</em>}
        {!!filters.billable && <em> {filters.billable}</em>}
        {!filters.text && !filters.billable && <em> None</em>}
      </div>
      { showTotal && filters.billable  && <div>Repeating Invoice Total (Annual): <span>${Math.round(total).toLocaleString()}</span></div> }
    </div>

    

    <div className="dashboard-item-container">
      {stocks.map((x: Stock, index: number) => <DashboardItem key={index} stock={x} />)}
    </div>

    <p className="num-displayed">Showing {stocks.length} of {dashboard_stocks.length}
      {archivedMatchCount > 0 && <span style={{color: 'red', marginLeft: '8px'}}>'{filters.text}' exists in Archived ({archivedMatchCount})</span>}
    </p>
    <DashboardTable stocks={stocks} />

  </Style>
}

// const areStatesEqual = (next: any, prev: any) => {
//   return prev.filters.text === next.filters.text
//   && prev.filters.billable === next.filters.billable
//     && prev.dashboard_stocks === next.dashboard_stocks;
// }
export default Dashboard